import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { connectState } from '@examdojo/angular/util';
import { distinctUntilDeepChanged } from '@examdojo/core/rxjs';
import { ImageChatMessageOrigin, ImageChatMessageUIModel } from '../../models';
import { ImageChatAgentRemoteMessageComponent } from '../agent-remote-message/agent-remote-message.component';
import { ImageChatUserMessageComponent } from '../user-message/user-message.component';

@Component({
  selector: 'dojo-image-chat-message',
  standalone: true,
  imports: [ImageChatAgentRemoteMessageComponent, ImageChatUserMessageComponent],
  templateUrl: './chat-message.component.html',
  host: { class: 'block' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImageChatMessageComponent {
  readonly message = input.required<ImageChatMessageUIModel>();

  readonly ChatMessageOrigin = ImageChatMessageOrigin;

  readonly state = connectState({
    message: toObservable(this.message).pipe(distinctUntilDeepChanged()),
  });
}
